"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Option = void 0;
const React = __importStar(require("react"));
const Checkbox_1 = __importDefault(require("@mulesoft/anypoint-components/raw/components/Checkbox"));
const Radio_1 = __importDefault(require("@mulesoft/anypoint-components/raw/components/Radio"));
const styles = __importStar(require("./OptionGroup.css"));
const constants_1 = require("../../constants");
const Option = (props) => {
    const { id, multiple, disabled, option, onCheck } = props;
    const { label, key, checked } = option;
    const handleMultiCheck = (e) => onCheck(key, e.value);
    const handleSingleCheck = () => onCheck(key, true);
    const componentClassName = `${constants_1.ANG_CSS_PREFIX}-option-group-option`;
    return (React.createElement("div", { className: `${componentClassName} ${styles.option}`, "data-test-id": `${id}-option-wrapper` }, multiple ? (React.createElement(Checkbox_1.default, { onChange: handleMultiCheck, checked: checked, disabled: disabled, label: label, testId: `${id}-option-multi` })) : (React.createElement(Radio_1.default, { onChange: handleSingleCheck, value: key, checked: checked, disabled: disabled, label: label, testId: `${id}-option-single` }))));
};
exports.Option = Option;
exports.default = exports.Option;
